var _defs, _path, _polygon, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e746650c-83f8-4232-83da-5a148bf9f584",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e3b681b8-9fec-4fe4-bb2b-5af09e48ae3c{fill:#2ed9c3;}.b86163df-b4df-4397-bea1-eab0ee62b987{fill:#d5f7f3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e3b681b8-9fec-4fe4-bb2b-5af09e48ae3c",
    d: "M683.25,425.19a41,41,0,1,1,41-41A41,41,0,0,1,683.25,425.19Zm0-80a39,39,0,1,0,39,39A39.05,39.05,0,0,0,683.25,345.19Z",
    transform: "translate(-642.25 -343.19)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b86163df-b4df-4397-bea1-eab0ee62b987",
    points: "47.6 45.42 45.84 48.23 46.02 51.74 57.6 63.32 60.94 65.08 64.27 63.32 64.8 58.76 52.86 47.17 49.7 45.07 47.6 45.42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e3b681b8-9fec-4fe4-bb2b-5af09e48ae3c",
    d: "M676.23,395a18.43,18.43,0,1,1,18.42-18.43A18.45,18.45,0,0,1,676.23,395Zm0-34.95a16.53,16.53,0,1,0,16.52,16.52A16.54,16.54,0,0,0,676.23,360Z",
    transform: "translate(-642.25 -343.19)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e3b681b8-9fec-4fe4-bb2b-5af09e48ae3c",
    d: "M676.23,391.3A14.74,14.74,0,1,1,691,376.56,14.75,14.75,0,0,1,676.23,391.3Zm0-28a13.22,13.22,0,1,0,13.22,13.22A13.23,13.23,0,0,0,676.23,363.34Z",
    transform: "translate(-642.25 -343.19)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "e3b681b8-9fec-4fe4-bb2b-5af09e48ae3c",
    d: "M703.27,409a5,5,0,0,1-3.5-1.44l-11.42-11.43a4.95,4.95,0,0,1,7-7l11.42,11.42a4.95,4.95,0,0,1-3.5,8.45Zm-2.16-2.79a3.05,3.05,0,0,0,4.32-4.31L694,390.43a3,3,0,0,0-4.31,4.31Z",
    transform: "translate(-642.25 -343.19)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiSearchIcon);
export default __webpack_public_path__ + "static/media/ui-search-icon.9f26b3ed9ad11acf37f7dcd9d387afbc.svg";
export { ForwardRef as ReactComponent };